import type { CSSProperties } from 'react';

export const MINDMAP_METRIC_UNIT = 'NODES';
export const MOBILE_CONTROLS_SCALE = 0.9;

export const MINDMAP_CSS_VALUE = {
  None: 'none',
} as const;

export const MINDMAP_CONTAINER_STYLE: CSSProperties = {
  maxHeight: 'none',
};
